<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/organisation']"><img src="assets/images/admin/backarrow.png" /> Back to Organisation Management</a>
    <!-- <div class="logout">
        <b>Shubham</b>
        <a href="javascript:void(0);"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap ">
    <div class="formHeading">
        <h2>Create Organisation</h2>
    </div>
    <div class="formArea">
 <div class="dynamicBookWrap">
    <div class="container">
        <div class="row">
            <div class="resultWrap pt-3">
                <div class="resul_img">
                    <img src="assets/images/illus.png" />
                </div>
                 <h4>You have successfully created a new organisation!</h4>
                 <span class="divider"></span>
                 <!-- <p>Do you want to assign courses to the user right away?</p> -->
                 <br>
                 <br>
                 <a href="javascript:void(0);"  [routerLink]="['/organisation']" class="backPage ml-2 mr-2">Go back to organisation management</a>
                 <!-- <a href="javascript:void(0);" class="btn btn-primary download ml-2 mr-2">Yes, Assign Courses</a> -->
                 <div class="illusBtnWrap">
                </div>
            </div>
        </div>
    </div>
    </div>
    </div>
</div>